import { serializeJsonLd } from "@/common/utils/json-ld.utils";

type JsonLdProps = {
  item: unknown;
};

/**
 * Writes one JSON-LD script with serializeJsonLd.
 *
 * Replaces react-schemaorg's JsonLd, which HTML-escapes strings so a
 * URL or title with "&" reached Google as a literal "&amp;". The
 * serializer emits "&", "<" and ">" as JSON unicode escapes instead,
 * which keeps "</script" from closing the element and decodes to the
 * plain character for every JSON-LD consumer.
 */
export const JsonLd = ({ item }: JsonLdProps) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: serializeJsonLd(item) }}
  />
);
